var render = function render(){
  var _vm$createFormCustome, _vm$invoiceToDelete;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:items-stretch gap-4"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
  }, [_c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Customer ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.customers,
      "default": _vm.selectedCustomer,
      "optionLabel": "customer_name",
      "placeholder": "Pilih customer"
    },
    on: {
      "input": function (val) {
        _vm.selectedCustomer = val;
      }
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Search ")]), _c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": "Cari invoice..."
    },
    on: {
      "enter": _vm.onFilterChange
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end"
  }, [_c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Start Date ")]), _c('TextField', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.startDate,
      callback: function ($$v) {
        _vm.startDate = $$v;
      },
      expression: "startDate"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" End Date ")]), _c('TextField', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.endDate,
      callback: function ($$v) {
        _vm.endDate = $$v;
      },
      expression: "endDate"
    }
  })], 1), _c('div', {
    staticClass: "flex gap-2 w-full mt-2 md:mt-0"
  }, [_c('button', {
    staticClass: "flex-1 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": _vm.onFilterChange
    }
  }, [_vm._v(" Apply ")]), _c('button', {
    staticClass: "flex-1 px-4 py-2 border border-neutral-300 text-neutral-700 rounded-lg hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v(" Reset ")])])])])]), _c('div', {
    staticClass: "flex mdmax:w-full justify-end mb-4"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": _vm.openCreateInvoiceModal
    }
  }, [_vm._v(" + Buat Invoice ")])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/invoices/invoices/${entry.id || entry.invoice_id}`);
            }
          }
        }, [_vm._v(" Detail ")]), _c('button', {
          staticClass: "px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm",
          on: {
            "click": function ($event) {
              return _vm.openDeleteInvoiceModal(entry);
            }
          }
        }, [_vm._v(" Delete ")])]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'invoice_date' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(entry.invoice_date)) + " ")]) : column.field === 'total_amount' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.total_amount || entry.total_price || entry.total)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  }), _vm.tableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.createModalVisible,
      "width": "900px"
    },
    on: {
      "close": _vm.closeCreateInvoiceModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v(" Buat Invoice ")]), _c('p', {
    staticClass: "text-sm text-neutral-500 mb-6"
  }, [_vm._v(" Step " + _vm._s(_vm.createStep) + " dari 3 ")]), _vm.createStep === 1 ? _c('div', [_c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Invoice Date",
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.createForm.invoice_date,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "invoice_date", $$v);
      },
      expression: "createForm.invoice_date"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Customer ")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.customers,
      "default": _vm.createFormCustomer,
      "optionLabel": "customer_name",
      "placeholder": "Pilih customer"
    },
    on: {
      "input": _vm.onCustomerSelect
    }
  })], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('Textarea', {
    attrs: {
      "label": "Pickup Address",
      "required": "",
      "disabled": !_vm.createFormCustomer,
      "placeholder": "Alamat asal/pickup",
      "heightClass": "h-24"
    },
    model: {
      value: _vm.createForm.pickup_address,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "pickup_address", $$v);
      },
      expression: "createForm.pickup_address"
    }
  })], 1)]) : _vm.createStep === 2 ? _c('div', [_c('div', {
    staticClass: "flex justify-between items-end mb-4 mdmax:flex-col gap-3"
  }, [_c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Customer")]), _c('p', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(" " + _vm._s(((_vm$createFormCustome = _vm.createFormCustomer) === null || _vm$createFormCustome === void 0 ? void 0 : _vm$createFormCustome.customer_name) || "-") + " ")])]), _c('div', {
    staticClass: "flex gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-700 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.loadEligibleResi
    }
  }, [_vm._v(" Reload Eligible Resi ")])])]), _c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Search resi",
      "type": "text",
      "placeholder": "Cari resi_number / destination"
    },
    model: {
      value: _vm.resiSearch,
      callback: function ($$v) {
        _vm.resiSearch = $$v;
      },
      expression: "resiSearch"
    }
  })], 1), _c('div', {
    staticClass: "bg-white rounded-lg p-3 mb-4 shadow-sm"
  }, [_c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isAllResiSelected
    },
    on: {
      "change": function ($event) {
        return _vm.toggleSelectAllResi($event.target.checked);
      }
    }
  }), _vm._v(" Select all (filtered) ")])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.resiColumns,
      "list": _vm.filteredEligibleResi,
      "compact": ""
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref2) {
        var entry = _ref2.entry,
            column = _ref2.column;
        return [column.field === 'selected' ? _c('span', [_c('input', {
          staticClass: "w-4 h-4",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.selectedResiIdsSet.has(entry.id || entry.resi_id)
          },
          on: {
            "change": function ($event) {
              return _vm.toggleResi(entry, $event.target.checked);
            }
          }
        })]) : column.field === 'date' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(entry.date)) + " ")]) : column.field === 'total_price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.total_price)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  })], 1) : _c('div', [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": "VAT Percent",
      "type": "number",
      "placeholder": "1.1"
    },
    model: {
      value: _vm.createForm.vat_percent,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "vat_percent", $$v);
      },
      expression: "createForm.vat_percent"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Discount Percent",
      "type": "number",
      "placeholder": "0"
    },
    model: {
      value: _vm.createForm.discount_percentage,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "discount_percentage", $$v);
      },
      expression: "createForm.discount_percentage"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Invoice Number (Opsional)",
      "type": "text",
      "placeholder": "INV-001"
    },
    model: {
      value: _vm.createForm.invoice_number,
      callback: function ($$v) {
        _vm.$set(_vm.createForm, "invoice_number", $$v);
      },
      expression: "createForm.invoice_number"
    }
  })], 1), _c('div', {
    staticClass: "mt-4 bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-1"
  }, [_vm._v("Resi dipilih")]), _c('p', {
    staticClass: "text-neutral-800 font-bold"
  }, [_vm._v(" " + _vm._s(_vm.selectedResiIds.length) + " resi ")])])]), _c('div', {
    staticClass: "flex justify-between gap-3 mt-8"
  }, [_vm.createStep > 1 ? _c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": function ($event) {
        _vm.createStep--;
      }
    }
  }, [_vm._v(" Back ")]) : _vm._e(), _c('div', {
    staticClass: "flex-1"
  }), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": _vm.nextDisabled
    },
    on: {
      "click": _vm.onNextCreateStep
    }
  }, [_vm._v(" " + _vm._s(_vm.createStep === 3 ? "Submit" : "Next") + " ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteInvoiceModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v(" Hapus Invoice ")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus invoice "), _c('strong', [_vm._v(_vm._s((_vm$invoiceToDelete = _vm.invoiceToDelete) === null || _vm$invoiceToDelete === void 0 ? void 0 : _vm$invoiceToDelete.invoice_number))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteInvoiceModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDeleteInvoice
    }
  }, [_vm._v(" Hapus ")])])])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }